module.exports = __webpack_public_path__ + "static/loda-sm-ae91cb99b13ae736895f603fc6a2da99.jpg";